import { Box, Heading, Image, Text } from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useUserDetails } from "../hooks/useAuthQueries"
import { useOnboardingSetup } from "../hooks/usePortfolioQueries"
import PortfolioForm, { PortfolioFormData } from "../components/PortfolioForm"

const Welcome: React.FC = () => {
  const navigate = useNavigate()
  const { data: userDetails, isLoading: userLoading } = useUserDetails()
  const onboardingMutation = useOnboardingSetup()
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (userLoading) return
    if (userDetails?.data?.organisation?.isOnboarded) {
      navigate("/dashboard", { replace: true })
    }
  }, [userLoading, userDetails, navigate])

  const handleSubmit = async (data: PortfolioFormData) => {
    setIsSubmitting(true)
    try {
      await onboardingMutation.mutateAsync(data)
      navigate("/opportunities")
    } finally {
      setIsSubmitting(false)
    }
  }

  if (userLoading) return null

  return (
    <Box p={8}>
      <Image src="/greenflip_logo.png" alt="Greenflip" h="28px" mb={6} />
      <Heading size="xl" mb={1}>
        Welcome to Greenflip
      </Heading>
      <Text color="gray.600" mb={6}>
        Let's set up your first portfolio and define what you're looking for.
        Greenflip will source matching properties and notify you by email.
      </Text>
      <PortfolioForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        submitLabel="Get started →"
      />
    </Box>
  )
}

export default Welcome
